import { c as _c } from "react/compiler-runtime";
import { NOTIFICATION_SETTINGS_API } from 'modules/profile/notification-settings/hooks/use-notification-settings';
import { NotificationSettingsInterface } from 'modules/profile/notification-settings/types/notification-settings-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
export const usePaymentNotificationSettings = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.put
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher) {
    t1 = {
      updatePaymentNotification: data => fetcher(NOTIFICATION_SETTINGS_API, data)
    };
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};